import { DevBoxOperation as GeneratedDevBoxOperationBeta } from 'devcenter-internal-beta';
import {
    DevBoxOperationKind as GeneratedDevBoxOperationKindStable,
    DevBoxOperation as GeneratedDevBoxOperationStable,
    DevBoxOperationUnion as GeneratedDevBoxOperationUnionStable,
    DevBoxRepairOperationResult as GeneratedDevBoxRepairOperationResultStable,
    DevBoxRepairOperation as GeneratedDevBoxRepairOperationStable,
    DevBoxRepairOutcome as GeneratedDevBoxRepairOutcomeStable,
    DevBoxRestartOperation as GeneratedDevBoxRestartOperationStable,
    DevBoxRestoreSnapshotOperation as GeneratedDevBoxRestoreOperationStable,
    DevBoxStartOperation as GeneratedDevBoxStartOperationStable,
    DevBoxStopOperation as GeneratedDevBoxStopOperationStable,
    DevBoxCaptureSnapshotOperation as GeneratedDevBoxTakeSnapshotOperationStable,
} from 'devcenter-internal-stable';
import { UnionMap } from '../../types/union-map';

/**
 * Data Plane SDK shim models
 */

export type DevBoxOperationContract = GeneratedDevBoxOperationStable | GeneratedDevBoxOperationBeta;

export type DevBoxOperationUnionContract = GeneratedDevBoxOperationUnionStable;

export type DevBoxOperationKindContract = GeneratedDevBoxOperationKindStable;

export const DevBoxOperationKindContract: UnionMap<DevBoxOperationKindContract> = {
    Repair: 'Repair',
    Restart: 'Restart',
    Start: 'Start',
    Stop: 'Stop',
    RestoreSnapshot: 'RestoreSnapshot',
    CaptureSnapshot: 'CaptureSnapshot',
};

export type DevBoxRepairOperationContract = GeneratedDevBoxRepairOperationStable;
export type DevBoxRepairOperationResultContract = GeneratedDevBoxRepairOperationResultStable;
export type DevBoxRepairOutcomeContract = GeneratedDevBoxRepairOutcomeStable;

export type DevBoxTakeSnapshotOperationContract = GeneratedDevBoxTakeSnapshotOperationStable;

export type DevBoxRestoreOperationContract = GeneratedDevBoxRestoreOperationStable;

export const DevBoxRepairOutcomeContract: UnionMap<DevBoxRepairOutcomeContract> = {
    FixApplied: 'FixApplied',
    IssuesDetected: 'IssuesDetected',
    NoIssuesDetected: 'NoIssuesDetected',
};

export type DevBoxRestartOperationContract = GeneratedDevBoxRestartOperationStable;
export type DevBoxStartOperationContract = GeneratedDevBoxStartOperationStable;
export type DevBoxStopOperationContract = GeneratedDevBoxStopOperationStable;

/**
 * Type guards
 */
export const isDevBoxRepairOperationContract = (
    contract: DevBoxOperationContract
): contract is DevBoxRepairOperationContract => contract.kind === DevBoxOperationKindContract.Repair;

export const isDevBoxRepairOutcomeContract = (value: unknown): value is DevBoxRepairOutcomeContract =>
    value === DevBoxRepairOutcomeContract.FixApplied ||
    value === DevBoxRepairOutcomeContract.IssuesDetected ||
    value === DevBoxRepairOutcomeContract.NoIssuesDetected;

export const isDevBoxTakeSnapshotOperationContract = (
    contract: DevBoxOperationContract
): contract is DevBoxTakeSnapshotOperationContract => contract.kind === DevBoxOperationKindContract.CaptureSnapshot;

export const isDevBoxRestartOperationContract = (
    contract: DevBoxOperationContract
): contract is DevBoxRestartOperationContract => contract.kind === DevBoxOperationKindContract.Restart;

export const isDevBoxStartOperationContract = (
    contract: DevBoxOperationContract
): contract is DevBoxStartOperationContract => contract.kind === DevBoxOperationKindContract.Start;

export const isDevBoxStopOperationContract = (
    contract: DevBoxOperationContract
): contract is DevBoxStopOperationContract => contract.kind === DevBoxOperationKindContract.Stop;

export const isDevBoxRestoreOperationContract = (
    contract: DevBoxOperationContract
): contract is DevBoxRestoreOperationContract => contract.kind === DevBoxOperationKindContract.RestoreSnapshot;
